var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m10.29 17.571-3.863-3.865L5 19zM16.603 5.403a1.4 1.4 0 0 0-.99-.403c-.353 0-.723.135-.991.403l-7.254 7.26 3.963 3.967 7.253-7.26a1.39 1.39 0 0 0 0-1.983z",
  clipRule: "evenodd"
})));
export { SvgEdit as ReactComponent };